import React, { useState, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ReactComponent as CloseIcon } from "../../../../../assets/icons/close.svg";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import CustomInput from "../../../../../global/components/CustomInput/CustomInput";
import CustomDialog from "../../../../../global/components/CustomModal/CustomModal";
import ShowAllStyles from "../../ShowAll/ShowAll.styles";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import { AddLoanApi } from "../AddLoanServices";
import { findUserLoanDeclaration, updateLoan } from "../AddRole/roleService";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";

interface CustomProps {
  isDialogOpen: boolean;
  handleCloseAddTeamMetaData: Function;
  idd: string;
  setIdd: Function;
  userId: string;
}

const AddLoan = (props: CustomProps) => {
  const [apiResponse, setApiResponse] = useState(false);
  const [formValues, setFormValues] = useState({
    loan_acc: "",
    loan_amt: "",
    loan_emi: "",
    start_from: "",
    updated_amt: "",
    status: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    loan_acc: "",
    loan_amt: "",
    loan_emi: "",
    start_from: "",
    updated_amt: "",
  });

  useEffect(() => {
    if (props.isDialogOpen) {
      init();
    } else {
      props.setIdd("");
      setFormValues({
        loan_acc: "",
        loan_amt: "",
        loan_emi: "",
        start_from: "",
        updated_amt: "",
        status: "",
      });
    }
  }, [props.isDialogOpen]);

  const init = async () => {
    try {
      if (props.idd && props.idd != "") {
        const response: any = await findUserLoanDeclaration(props.idd);
        customErrorHandler(response);
        var now = new Date(new Date(response.data.start_from));
        var month: any = (now.getMonth() + 1);
        var day: any = now.getDate();
        if (month < 10)
          month = "0" + month;
        if (day < 10)
          day = "0" + day;
        var today = now.getFullYear() + '-' + month + '-' + day;

        setFormValues({
          loan_acc: response.data?.loan_acc,
          loan_amt: response.data?.loan_amt,
          loan_emi: response.data?.loan_emi,
          start_from: today,
          updated_amt: response.data?.updated_amt,
          status: response.data?.status,
        });
      }
    } catch (error: any) {
      openErrorNotification(isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleFormSubmit = async () => {
    if (isFormValid()) {
      try {
        setApiResponse(true);
        if (props.idd.length > 0) {
          const body: any = {
            ...formValues,
            userId: props.userId,
            id: props.idd
          };
          const response = await updateLoan(body);
          customErrorHandler(response);
          if (response?.success === 1) {
            openSuccessNotification(response?.message);
          }
          props.handleCloseAddTeamMetaData();
          setApiResponse(false);
        } else {
          const body: any = {
            ...formValues,
            status: '1',
            userId: props.userId,
          };
          const response = await AddLoanApi(body);
          customErrorHandler(response);
          if (response?.success === 1) {
            openSuccessNotification(response?.message);
          }
          props.handleCloseAddTeamMetaData();
          setApiResponse(false);
        }
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }

      // Clear the form values after submission if needed
      setFormValues({
        loan_acc: "",
        loan_amt: "",
        loan_emi: "",
        start_from: "",
        updated_amt: "",
        status: "",
      });
      setValidationErrors({
        loan_acc: "",
        loan_amt: "",
        loan_emi: "",
        start_from: "",
        updated_amt: "",
      });
    }
  };

  const isFormValid = () => {
    let isValid = true;
    const errors = {
      loan_acc: "",
      loan_amt: "",
      loan_emi: "",
      start_from: "",
      updated_amt: "",
    };
    console.log(formValues);
    if (formValues.loan_acc.trim() === "") {
      errors.loan_acc = "Please enter loan Account.";
      isValid = false;
    }

    if (formValues.loan_amt === "") {
      errors.loan_amt = "Please enter loan amount.";
      isValid = false;
    }

    if (formValues.loan_emi === "") {
      errors.loan_emi = "Please enter loan EMI.";
      isValid = false;
    }

    if (formValues.start_from.trim() === "") {
      errors.start_from = "Please enter start date.";
      isValid = false;
    }

    if (formValues.updated_amt === "") {
      errors.updated_amt = "Please enter updated amount.";
      isValid = false;
    }

    setValidationErrors(errors);
    return isValid;
  };

  const classes = ShowAllStyles;

  const dialogHeaderContentLoan = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcon onClick={() => props.handleCloseAddTeamMetaData()} />
      </Box>
    );
  };

  const dialogTitleContentLoan = () => {
    return (
      <>
        <Box sx={classes.content}>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={classes.pageHeading}>{props.idd.length > 0 ? "Update Loan" : "Add Loan"}</Typography>
              <Typography sx={classes.pageSubHeading}>
                Change your account status
              </Typography>
            </Grid>
            <Grid container xs={6} rowSpacing={3} columnSpacing={5} mt={2}>
              <Grid item xs={6}>
                <CustomInput
                  label="Loan Account"
                  value={formValues.loan_acc}
                  onChange={handleInputChange}
                  name="loan_acc"
                  placeHolder="Loan Account"
                  error={validationErrors.loan_acc !== ""}
                  helperText={validationErrors.loan_acc}
                />
              </Grid>

              <Grid item xs={6}>
                <CustomInput
                  type="number"
                  label="Loan Amount"
                  value={formValues.loan_amt}
                  onChange={handleInputChange}
                  name="loan_amt"
                  placeHolder="Loan Amount"
                  error={validationErrors.loan_amt !== ""}
                  helperText={validationErrors.loan_amt}
                />
              </Grid>

              <Grid item xs={6}>
                <CustomInput
                  type="number"
                  label="Loan EMI"
                  value={formValues.loan_emi}
                  onChange={handleInputChange}
                  name="loan_emi"
                  placeHolder="Loan EMI"
                  error={validationErrors.loan_emi !== ""}
                  helperText={validationErrors.loan_emi}
                />
              </Grid>

              <Grid item xs={6}>
                <CustomInput
                  type="date"
                  label="Start from"
                  value={formValues.start_from}
                  onChange={handleInputChange}
                  name="start_from"
                  placeHolder="Start from (dd-mm-yyyy)"
                  error={validationErrors.start_from !== ""}
                  helperText={validationErrors.start_from}
                />
              </Grid>

              <Grid item xs={6}>
                <CustomInput
                  type="number"
                  label="Updated amount"
                  value={formValues.updated_amt}
                  onChange={handleInputChange}
                  name="updated_amt"
                  placeHolder="Updated amount"
                  error={validationErrors.updated_amt !== ""}
                  helperText={validationErrors.updated_amt}
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={classes.buttonWrapperDialog}>

                  <CustomButton
                    label="Cancel"
                    onClick={() => {
                      props.handleCloseAddTeamMetaData();
                    }}
                    buttonType="secondaryBtn"
                  />

                  <CustomButton
                    label="Submit"
                    onClick={handleFormSubmit}
                    buttonType="primaryBtn"
                  />

                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  return (
    <>
      <CustomDialog
        fullScreen={true}
        isDialogOpen={props.isDialogOpen}
        dialogHeaderContent={dialogHeaderContentLoan()}
        dialogTitleContent={dialogTitleContentLoan()}
        handleDialogClose={props.handleCloseAddTeamMetaData}
      />
      {apiResponse && <CustomLoader apiResponse={false} />}
    </>
  );
};

export default AddLoan;